<template>
  <div>
    <!-- 题库 -->
    <div
      class="wjTypeChildQuestion"
      style="margin-left: 80px; margin-top: 62px"
    >
      <div class="tk_item" style="height: 0px !important"></div>
      <div
        class="tk_item"
        v-for="(wjType, index) in wjTypeList"
        :key="index"
        @click="showQuestionList(index, wjType)"
      >
        <div class="display_inline" style="width: 5%"></div>
        <div
          class="display_inline"
          style="width: 65%; font-size: 16px"
          v-if="index != selectTypeIndex"
        >
          {{ wjType.questionnaireTypeName }}
        </div>
        <div
          class="display_inline"
          style="width: 65%; font-size: 16px; color: cornflowerblue"
          v-if="index == selectTypeIndex"
        >
          {{ wjType.questionnaireTypeName }}
        </div>
        <div class="display_inline" style="width: 25%; text-align: right">
          <img
            src="../assets/tk/jt_def_icon.png"
            v-if="index != selectTypeIndex"
          />
          <img
            src="../assets/tk/jt_sel_icon.png"
            v-if="index == selectTypeIndex"
          />
        </div>
      </div>
    </div>

    <!--000000000000000000000000000000-->
    <div
      id="wenjuan_list"
      class="wjEdit"
      :style="{ height: rightheight + 'px' }"
      style="
        width: calc(100% - 720px);
        overflow-y: auto;
        float: left;
        margin-top: 62px;
      "
    >
      <div
        :style="{
          position: 'absolute',
          top: top - 40 + 'px',
          left: left + 'px',
          height: '30px',
          zIndex: 999,
          display: display,
        }"
      >
        <table>
          <tr>
            <td class="operate_td">
              <i class="el-icon-picture"></i>
            </td>
            <td class="operate_td" @click="outerVisible = true">
              <i class="el-icon-tickets"></i>
            </td>
          </tr>
        </table>
      </div>

      <el-container>
        <el-main @mousewheel="scroll">
          <el-row :gutter="10" class="item_container">
            <el-row :gutter="10">
              <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                <span style="color: #fff">题</span>
              </el-col>
              <el-col
                :xs="22"
                :sm="22"
                :md="22"
                :lg="22"
                :xl="22"
                class="item_container_title"
              >
                <el-input
                  placeholder="请输入问卷标题"
                  class="wjTitle"
                  @focus="showAdvance"
                  v-model="curWjInfo.wjTitle"
                  @blur="wjedit()"
                ></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-top: 12px !important">
              <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                <span style="color: #fff">题</span>
              </el-col>
              <el-col
                :xs="22"
                :sm="22"
                :md="22"
                :lg="22"
                :xl="22"
                class="item_container_title"
              >
                <el-input
                  placeholder="请输入问卷欢迎语"
                  @focus="showAdvance"
                  v-model="curWjInfo.content"
                  @blur="wjedit()"
                ></el-input>
              </el-col>
            </el-row>
          </el-row>
          <el-row v-if="!questionlist || !questionlist.length">
            <div
              style="
                text-align: center;
                height: 300px;
                line-height: 300px;
                border: 1px blue dashed;
              "
            >
              点击题型可添加题目
            </div>
          </el-row>
          <el-row
            :gutter="10"
            :id="index"
            class="item_container"
            v-for="(item, index) in questionlist"
            :key="index"
          >
            <!-- 手机号 -->
            <QuestionBlank
              v-if="item.questionsTypeId == 2"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
            />
            <!-- 当行输入框 -->
            <QuestionBlank
              v-if="item.questionsTypeId == 3"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
            />
            <!-- 多行输入框 -->
            <QuestionBlankMult
              v-if="item.questionsTypeId == 4"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
            />
            <!-- 填空题 -->
            <QuestionBlank
              v-if="item.questionsTypeId == 5"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
            />
            <!-- 图片选择 -->
            <QuestionImage
              v-model="value1"
              v-if="item.questionsTypeId == 6"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 单项选择题 -->
            <QuestionSingle
              v-if="item.questionsTypeId == 8"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
            />
            <!-- 下拉框 -->
            <QuestionDropDownBox
              v-model="value1"
              v-if="item.questionsTypeId == 9"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 多项选择 -->
            <QuestionMult2
              v-if="item.questionsTypeId == 10"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
            />
            <!-- 星级评分 -->
            <QuestionRate
              v-if="item.questionsTypeId == 11"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
            />
            <!-- 判断题 -->
            <QuestionJudge
              v-if="item.questionsTypeId == 12"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
            />
            <!-- 日期选择 -->
            <QuestionDate
              v-model="value1"
              v-if="item.questionsTypeId == 13"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 排序题 -->
            <QuestionSort
              v-model="value1"
              v-if="item.questionsTypeId == 14"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 地址位置 -->
            <QuestionAddress
              v-model="value1"
              v-if="item.questionsTypeId == 15"
              :index="index"
              :question="item"
              :titleNumber="titleNumber"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 城市选择 -->
            <QuestionCity
              v-model="value1"
              v-if="item.questionsTypeId == 16"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :titleNumber="titleNumber"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 时间选择 -->
            <QuestionTime
              v-model="value1"
              v-if="item.questionsTypeId == 17"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 矩阵单选 -->
            <QuestionRectSingle
              v-if="item.questionsTypeId == 19"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 矩阵多选 -->
            <QuestionRectMult
              v-if="item.questionsTypeId == 20"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 矩阵星级评分 -->
            <QuestionMatrixRate
              v-if="item.questionsTypeId == 21"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 矩阵填空 -->
            <QuestionMatrixBlank
              v-if="item.questionsTypeId == 22"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 段落标题 -->
            <QuestionParagraph
              v-if="item.questionsTypeId == 25"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 分页 -->
            <QuestionPaging
              v-if="item.questionsTypeId == 26"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 上传文件 -->
            <QuestionUploadFile
              v-if="item.questionsTypeId == 33"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 横向填空 -->
            <QuestionCrosswiseBlank
              v-if="item.questionsTypeId == 34"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
            <!-- 多项填空 -->
            <QuestionMu
              v-model="value1"
              v-if="item.questionsTypeId == 35"
              :index="index"
              :question="item"
              :editIndex="editIndex"
              :editOptionIndex="editOptionIndex"
              @wjaddquestionoption="wjaddquestionoption"
              @wjdelquestionoption="wjdelquestionoption"
              @addmatrixquestionsoption="addMatrixQuestionsOption"
              @questiondel="questiondel"
              @showAdvance="showAdvance"
              @setEditIndex="setEditIndex"
              @setEditOptionIndex="setEditOptionIndex"
              @wjupdquestionoption="wjupdquestionoption"
              @wjupdoption="wjupdoption"
              @addquestionitem="addQuestionItem"
            />
          </el-row>
        </el-main>
      </el-container>
    </div>

    <div
      class="wjType"
      :Style="{ height: rightheight + 'px' }"
      style="overflow-y: auto; background: #fff"
    >
      <div
        v-if="editIndex != -1"
        style="width: 100%; height: 45rem; margin-top: 2px; overflow-y: auto"
        class="display_inline"
      >
        <el-divider></el-divider>
        <div class="operate_item">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <span class="left" style="font-weight: bold"
              >Q:{{ editIndex + 1 }}题目设置</span
            >
          </el-col>
          <el-col
            :xs="12"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            style="text-align: right"
          >
          </el-col>
        </div>
        <div class="operate_item" style="border-bottom: 1px solid #ccc">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <span class="left">整题设置</span>
          </el-col>
        </div>
        <!-- 手机号 -->
        <div v-if="questionsTypeId == 2" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID, ifMustAnswer)"
              ></el-switch
            ></span>
          </div>
          <div
            class="heiSetting"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <span class="left">输入框大小</span>
            <div class="right tab_layout input_size w-btn-group">
              <span
                :class="{ activeCheck: currentSort == 0 }"
                @click="setInputSize(0, switchID)"
                >小</span
              >
              <span
                :class="{ activeCheck: currentSort == 1 }"
                @click="setInputSize(1, switchID)"
                >中</span
              >
              <span
                :class="{ activeCheck: currentSort == 2 }"
                @click="setInputSize(2, switchID)"
                >大</span
              >
            </div>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置
              <i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right" style="color: #0080ff">
              <a>设置</a>
            </span>
          </div>
          <div class="heiSetting">
            <span class="left">内容限制</span>
            <span class="right">
              <el-select
                v-model="content.ContentRes"
                placeholder="请选择"
                @change="contents(content.ContentRes, switchID)"
              >
                <el-option
                  v-for="item in ContentRestrictions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
          </div>
        </div>
        <!-- 单行输入框 -->
        <div v-if="questionsTypeId == 3" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">输入框大小</span>
            <div class="right tab_layout input_size w-btn-group">
              <span
                :class="{ activeCheck: currentSort == 0 }"
                @click="setInputSize(0, switchID)"
                >小</span
              >
              <span
                :class="{ activeCheck: currentSort == 1 }"
                @click="setInputSize(1, switchID)"
                >中</span
              >
              <span
                :class="{ activeCheck: currentSort == 2 }"
                @click="setInputSize(2, switchID)"
                >大</span
              >
            </div>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置
              <i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <div class="heiSetting">
            <span class="left">内容限制</span>
            <span class="right">
              <el-select
                v-model="content.lineInput"
                placeholder="请选择"
                @change="contents(content.lineInput, switchID)"
              >
                <el-option
                  v-for="item in ContentRestrictions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
          </div>
          <div class="heiSetting">
            <span class="left">字数限制</span>
            <div class="right" style="font-size: 14px">
              <span class="heade" @click="startnum--">-</span>
              <span class="numLimit">{{ startnum }}</span>
              <span class="heade" @click="startnum++">+</span>
              <span style="margin: 0 5px">至</span>
              <span class="heade" @click="endnum--">-</span>
              <span class="numLimit">{{ endnum }}</span>
              <span class="heade" @click="endnum++">+</span>
            </div>
          </div>
          <div class="heiSetting">
            <span class="left">题型切换</span>
            <div class="right tab_layout input_size w-btn-group">
              <span
                :class="{ activeCheck: questionlineRank == 0 }"
                @click="switchoverType(0, switchID)"
                >单行</span
              >
              <span
                :class="{ activeCheck: questionlineRank == 1 }"
                @click="switchoverType(1, switchID)"
                >多行</span
              >
            </div>
          </div>
        </div>
        <!-- 多行输入框 -->
        <div v-if="questionsTypeId == 4" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">输入框大小</span>
            <div class="right tab_layout input_size w-btn-group">
              <span
                :class="{ activeCheck: currentSort == 0 }"
                @click="setInputSize(0, switchID)"
                >小</span
              >
              <span
                :class="{ activeCheck: currentSort == 1 }"
                @click="setInputSize(1, switchID)"
                >中</span
              >
              <span
                :class="{ activeCheck: currentSort == 2 }"
                @click="setInputSize(2, switchID)"
                >大</span
              >
            </div>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置
              <i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <div class="heiSetting">
            <span class="left">内容限制</span>
            <span class="right">
              <el-select
                v-model="content.multiline"
                placeholder="请选择"
                @change="contents(content.multiline, switchID)"
              >
                <el-option
                  v-for="item in ContentRestrictions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
          </div>
          <div class="heiSetting">
            <span class="left">字数限制</span>
            <div class="right" style="font-size: 14px">
              <span class="heade" @click="startnum--">-</span>
              <span class="numLimit">{{ startnum }}</span>
              <span class="heade" @click="startnum++">+</span>
              <span style="margin: 0 5px">至</span>
              <span class="heade" @click="endnum--">-</span>
              <span class="numLimit">{{ endnum }}</span>
              <span class="heade" @click="endnum++">+</span>
            </div>
          </div>
          <div class="heiSetting">
            <span class="left">题型切换</span>
            <div class="right tab_layout input_size w-btn-group">
              <span
                :class="{ activeCheck: questionlineRank == 0 }"
                @click="switchoverType(0, switchID)"
                >单行</span
              >
              <span
                :class="{ activeCheck: questionlineRank == 1 }"
                @click="switchoverType(1, switchID)"
                >多行</span
              >
            </div>
          </div>
        </div>
        <!-- 填空题 -->
        <div v-if="questionsTypeId == 5" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">输入框大小</span>
            <div class="right tab_layout input_size w-btn-group">
              <div class="right tab_layout input_size w-btn-group">
                <span
                  :class="{ activeCheck: currentSort == 0 }"
                  @click="setInputSize(0, switchID)"
                  >小</span
                >
                <span
                  :class="{ activeCheck: currentSort == 1 }"
                  @click="setInputSize(1, switchID)"
                  >中</span
                >
                <span
                  :class="{ activeCheck: currentSort == 2 }"
                  @click="setInputSize(2, switchID)"
                  >大</span
                >
              </div>
            </div>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置
              <i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
            "
          >
            填写限制
          </p>
          <div class="heiSetting">
            <span class="left">内容限制</span>
            <span class="right">
              <el-select
                v-model="content.gapFil"
                placeholder="请选择"
                @change="contents(content.gapFil, switchID)"
              >
                <el-option
                  v-for="item in ContentRestrictions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
          </div>
          <div class="heiSetting">
            <span class="left">最少填写</span>
            <div class="right" style="display: flex">
              <el-input
                v-model="inputLeast"
                @change="inpLeast(inputLeast, switchID)"
              ></el-input
              ><a style="margin-left: 4px">字</a>
            </div>
          </div>
          <div class="heiSetting">
            <span class="left">最多填写</span>
            <div class="right" style="display: flex">
              <el-input
                v-model="inputMoster"
                @change="inpMoster(inputMoster, switchID)"
              ></el-input
              ><a style="margin-left: 4px">字</a>
            </div>
          </div>
        </div>
        <!-- 图片选择 -->
        <div v-if="questionsTypeId == 6">
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">题型</span>
            <div class="right tab_layout">
              <span
                :class="{ activeCheck: questionsType == 1 }"
                @click="setTopic(1, switchID)"
                >单选</span
              >
              <span
                :class="{ activeCheck: questionsType == 2 }"
                @click="setTopic(2, switchID)"
                >多选</span
              >
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
          >
            选项设置
          </p>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项随机排列</span>
            <span class="right"
              ><el-switch
                v-model="optionIfRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RandomArr(switchID)"
              ></el-switch
            ></span>
          </div>
          <div
            v-if="optionIfRandom == 1"
            style="width: 343px; height: 50px; background: #fafafa"
          >
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left">固定最后一个选项</span>
              <span class="right"
                ><el-switch
                  v-model="ifFixedLastOption"
                  :active-value="1"
                  :inactive-value="0"
                  @change="fixation(switchID)"
                ></el-switch
              ></span>
            </div>
          </div>
        </div>
        <!-- 单选题 -->
        <div v-if="questionsTypeId == 8">
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">题型</span>
            <div class="right tab_layout">
              <span
                :class="{ activeCheck: questionsType == 1 }"
                @click="setTopic(1, switchID)"
                >单选</span
              >
              <span
                :class="{ activeCheck: questionsType == 2 }"
                @click="setTopic(2, switchID)"
                >多选</span
              >
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
          >
            选项设置
          </p>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >分组<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项随机排列</span>
            <span class="right"
              ><el-switch
                v-model="optionIfRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RandomArr(switchID)"
              ></el-switch
            ></span>
          </div>
          <div
            v-if="optionIfRandom == 1"
            style="width: 343px; height: 100px; background: #fafafa"
          >
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left"
                >组内随机
                <i
                  class="el-icon-question"
                  style="width: 24px; height: 24px; color: #ccc"
                ></i
              ></span>
              <span class="right"
                ><el-switch
                  v-model="inGroupRandom"
                  :active-value="1"
                  :inactive-value="0"
                  @change="inGroupR(switchID)"
                ></el-switch
              ></span>
            </div>
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left"
                >组间随机<i
                  class="el-icon-question"
                  style="width: 24px; height: 24px; color: #ccc"
                ></i
              ></span>
              <span class="right"
                ><el-switch
                  v-model="betweenGroupRandom"
                  :active-value="1"
                  :inactive-value="0"
                  @change="betRan(switchID)"
                ></el-switch
              ></span>
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项布局</span>
            <div class="right tab_layout">
              <span
                :class="{ activeCheck: questionLayout == 1 }"
                @click="setLayout(1, switchID)"
                >单列</span
              >
              <span
                :class="{ activeCheck: questionLayout == 2 }"
                @click="setLayout(2, switchID)"
                >2列</span
              >
              <span
                :class="{ activeCheck: questionLayout == 3 }"
                @click="setLayout(3, switchID)"
                >3列</span
              >
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项关联</span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 下拉框 -->
        <div v-if="questionsTypeId == 9">
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">题型</span>
            <div class="right tab_layout">
              <span
                :class="{ activeCheck: questionsType == 1 }"
                @click="setTopic(1, switchID)"
                >单选</span
              >
              <span
                :class="{ activeCheck: questionsType == 2 }"
                @click="setTopic(2, switchID)"
                >多选</span
              >
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >逻辑设置
              <i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">
              <a>设置</a>
            </span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
          >
            选项设置
          </p>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项随机排列</span>
            <span class="right"
              ><el-switch
                v-model="optionIfRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RandomArr(switchID)"
              ></el-switch
            ></span>
          </div>
          <div
            v-if="optionIfRandom == 1"
            style="width: 343px; height: 100px; background: #fafafa"
          >
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left"
                >组内随机
                <i
                  class="el-icon-question"
                  style="width: 24px; height: 24px; color: #ccc"
                ></i
              ></span>
              <span class="right"
                ><el-switch
                  v-model="inGroupRandom"
                  :active-value="1"
                  :inactive-value="0"
                  @change="inGroupR(switchID)"
                ></el-switch
              ></span>
            </div>
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left"
                >组间随机<i
                  class="el-icon-question"
                  style="width: 24px; height: 24px; color: #ccc"
                ></i
              ></span>
              <span class="right"
                ><el-switch
                  v-model="betweenGroupRandom"
                  :active-value="1"
                  :inactive-value="0"
                  @change="betRan(switchID)"
                ></el-switch
              ></span>
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >选项关联<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 多选题 -->
        <div v-if="questionsTypeId == 10">
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">题型</span>
            <div class="right tab_layout">
              <span
                :class="{ activeCheck: questionsType == 1 }"
                @click="setTopic(1, switchID)"
                >单选</span
              >
              <span
                :class="{ activeCheck: questionsType == 2 }"
                @click="setTopic(2, switchID)"
                >多选</span
              >
            </div>
          </div>
          <div
            style="
              height: 80px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
          >
            <span
              class="left"
              style="width: 100%; height: 40px; line-height: 50px"
              >可选范围</span
            >
            <!-- <br> -->
            <div style="width: 100%; height: 40px; line-height: 20px">
              <div style="float: left; margin-left: 10px">
                <span>最少</span>
              </div>
              <div style="float: left">
                <span>最多</span>
              </div>
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >逻辑设置
              <i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">
              <a>设置</a>
            </span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
          >
            选项设置
          </p>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >分组<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项随机排列</span>
            <span class="right"
              ><el-switch
                v-model="optionIfRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RandomArr(switchID)"
              ></el-switch
            ></span>
          </div>
          <div
            v-if="optionIfRandom == 1"
            style="width: 343px; height: 100px; background: #fafafa"
          >
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left"
                >组内随机
                <i
                  class="el-icon-question"
                  style="width: 24px; height: 24px; color: #ccc"
                ></i
              ></span>
              <span class="right"
                ><el-switch
                  v-model="inGroupRandom"
                  :active-value="1"
                  :inactive-value="0"
                  @change="inGroupR(switchID)"
                ></el-switch
              ></span>
            </div>
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left"
                >组间随机<i
                  class="el-icon-question"
                  style="width: 24px; height: 24px; color: #ccc"
                ></i
              ></span>
              <span class="right"
                ><el-switch
                  v-model="betweenGroupRandom"
                  :active-value="1"
                  :inactive-value="0"
                  @change="betRan(switchID)"
                ></el-switch
              ></span>
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项布局</span>
            <div class="right tab_layout">
              <span
                :class="{ activeCheck: questionLayout == 1 }"
                @click="setLayout(1, switchID)"
                >单列</span
              >
              <span
                :class="{ activeCheck: questionLayout == 2 }"
                @click="setLayout(2, switchID)"
                >1列</span
              >
              <span
                :class="{ activeCheck: questionLayout == 3 }"
                @click="setLayout(3, switchID)"
                >2列</span
              >
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >选项关联<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 星级评分 -->
        <!-- 未写 -->
        <div v-if="questionsTypeId == 11" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
        </div>
        <!-- 判断题 -->
        <div v-if="questionsTypeId == 12" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 日期选择 -->
        <div v-if="questionsTypeId == 13" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 排序题 -->
        <div v-if="questionsTypeId == 14">
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
          >
            选项设置
          </p>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项随机排列</span>
            <span class="right"
              ><el-switch
                v-model="optionIfRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RandomArr(switchID)"
              ></el-switch
            ></span>
          </div>
          <div
            v-if="optionIfRandom == 1"
            style="width: 343px; height: 100px; background: #fafafa"
          >
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left"
                >组内随机
                <i
                  class="el-icon-question"
                  style="width: 24px; height: 24px; color: #ccc"
                ></i
              ></span>
              <span class="right"
                ><el-switch
                  v-model="inGroupRandom"
                  :active-value="1"
                  :inactive-value="0"
                  @change="inGroupR(switchID)"
                ></el-switch
              ></span>
            </div>
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left"
                >组间随机<i
                  class="el-icon-question"
                  style="width: 24px; height: 24px; color: #ccc"
                ></i
              ></span>
              <span class="right"
                ><el-switch
                  v-model="betweenGroupRandom"
                  :active-value="1"
                  :inactive-value="0"
                  @change="betRan(switchID)"
                ></el-switch
              ></span>
            </div>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">仅选出</span>
            <div class="right">
              <el-select
                v-model="choice.sortsnums"
                placeholder="请选择"
                @change="choiceNum(choice.sortsnums, switchID)"
              >
                <el-option
                  v-for="item in choiceContent"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option> </el-select
              >位
            </div>
          </div>
        </div>
        <!-- 地址位置 -->
        <div v-if="questionsTypeId == 15" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">自动定位</span>
            <span class="right"
              ><el-switch
                v-model="manualSetting"
                :active-value="1"
                :inactive-value="0"
                @change="manSet(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 城市选择 -->
        <div v-if="questionsTypeId == 16" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
            "
          >
            选项设置
          </p>
          <div style="font-size: 14px">
            <span>详细程度</span>
            <div
              v-for="(itemChoice, indexChoice) in cityChoice"
              :key="indexChoice"
            >
              <el-radio
                v-model="radioChoice"
                :label="itemChoice.value"
                @change="setDetails(switchID, itemChoice)"
                >{{ itemChoice.label }}</el-radio
              >
            </div>
          </div>
        </div>
        <!-- 时间选择 -->
        <div v-if="questionsTypeId == 17" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 矩阵单选 -->
        <div v-if="questionsTypeId == 19" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">题型</span>
            <div class="right tab_layout">
              <span
                :class="{ activeCheck: questionsType == 1 }"
                @click="setTopic(1, switchID)"
                >单选</span
              >
              <span
                :class="{ activeCheck: questionsType == 2 }"
                @click="setTopic(2, switchID)"
                >多选</span
              >
            </div>
          </div>
          <div class="heiSetting">
            <span class="left">「行」随机排列</span>
            <span class="right"
              ><el-switch
                v-model="matrixLineRandom"
                :active-value="1"
                :inactive-value="0"
                @change="lineMartix(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">「列」随机排列</span>
            <span class="right"
              ><el-switch
                v-model="matrixRankRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RankMartix(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">矩阵行列交换</span>
            <span class="right"
              ><el-switch
                v-model="lineRankExchange"
                :active-value="1"
                :inactive-value="0"
                @change="lineRank(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 矩阵多选 -->
        <div v-if="questionsTypeId == 20" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">题型</span>
            <div class="right tab_layout">
              <span
                :class="{ activeCheck: questionsType == 1 }"
                @click="setTopic(1, switchID)"
                >单选</span
              >
              <span
                :class="{ activeCheck: questionsType == 2 }"
                @click="setTopic(2, switchID)"
                >多选</span
              >
            </div>
          </div>
          <!-- <div style="height: 90px; border-bottom: 1px solid #ccc"></div> -->
          <div class="heiSetting">
            <span class="left">「行」随机排列</span>
            <span class="right"
              ><el-switch
                v-model="matrixLineRandom"
                :active-value="1"
                :inactive-value="0"
                @change="lineMartix(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">「列」随机排列</span>
            <span class="right"
              ><el-switch
                v-model="matrixRankRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RankMartix(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">矩阵行列交换</span>
            <span class="right"
              ><el-switch
                v-model="lineRankExchange"
                :active-value="1"
                :inactive-value="0"
                @change="lineRank(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 矩阵星级评分 -->
        <div v-if="questionsTypeId == 21" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">「行」随机排列</span>
            <span class="right"
              ><el-switch
                v-model="matrixLineRandom"
                :active-value="1"
                :inactive-value="0"
                @change="lineMartix(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">「列」随机排列</span>
            <span class="right"
              ><el-switch
                v-model="matrixRankRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RankMartix(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">矩阵行列交换</span>
            <span class="right"
              ><el-switch
                v-model="lineRankExchange"
                :active-value="1"
                :inactive-value="0"
                @change="lineRank(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>

        <!-- 矩阵填空 -->
        <div v-if="questionsTypeId == 22" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">「行」随机排列</span>
            <span class="right"
              ><el-switch
                v-model="matrixLineRandom"
                :active-value="1"
                :inactive-value="0"
                @change="lineMartix(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">「列」随机排列</span>
            <span class="right"
              ><el-switch
                v-model="matrixRankRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RankMartix(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left">矩阵行列交换</span>
            <span class="right"
              ><el-switch
                v-model="lineRankExchange"
                :active-value="1"
                :inactive-value="0"
                @change="lineRank(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 段落标题 -->
        <div v-if="questionsTypeId == 25" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left"
              >逻辑设置<i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 分页 -->
        <div v-if="questionsTypeId == 26" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
        </div>
        <!-- 文件上传 -->
        <div v-if="questionsTypeId == 33" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
        </div>
        <!-- 横向填空 -->
        <div v-if="questionsTypeId == 34" style="width: 90%; margin: 0 auto">
          <div class="heiSetting">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting">
            <span class="left"
              >逻辑设置
              <i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right">
              <a>设置</a>
            </span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
            "
          >
            填空属性
          </p>
          <div class="heiSetting">
            <span class="left">填空属性</span>
            <span class="right">设置</span>
          </div>
        </div>
        <!-- 多项填空 -->
        <div v-if="questionsTypeId == 35">
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">此题必答</span>
            <span class="right"
              ><el-switch
                v-model="ifMustAnswer"
                :active-value="1"
                :inactive-value="0"
                @change="mustAnswer(switchID)"
              ></el-switch
            ></span>
          </div>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left"
              >逻辑设置
              <i
                class="el-icon-question"
                style="width: 24px; height: 24px; color: #ccc"
              ></i
            ></span>
            <span class="right"></span>
          </div>
          <p
            style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
          >
            选项设置
          </p>
          <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">选项随机排列</span>
            <span class="right"
              ><el-switch
                v-model="optionIfRandom"
                :active-value="1"
                :inactive-value="0"
                @change="RandomArr(switchID)"
              ></el-switch
            ></span>
          </div>
          <div
            v-if="optionIfRandom == 1"
            style="width: 343px; height: 50px; background: #fafafa"
          >
            <div class="heiSetting" style="width: 90%; margin: 0 auto">
              <span class="left">固定最后一个选项</span>
              <span class="right"
                ><el-switch
                  v-model="ifFixedLastOption"
                  :active-value="1"
                  :inactive-value="0"
                  @change="fixation(switchID)"
                ></el-switch
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wjType" style="overflow-y: auto; background: #fff">
      <el-dialog
        :title="`题库【${curTkType.questionnaireTypeName}】`"
        :visible.sync="centerDialogVisible"
        width="30%"
        center
		:close-on-click-modal="false"
      >
        <el-table :data="tkList">
          <el-table-column
            property="questionsName"
            label="问题"
          ></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="addTkItem(scope.row)"
                >添加</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="centerDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QuestionSingle from "@/components/QuestionSingle";
import QuestionJudge from "@/components/QuestionJudge";
import QuestionMult2 from "@/components/QuestionMult2";
import QuestionBlank from "@/components/QuestionBlank";
import QuestionBlankMult from "@/components/QuestionBlankMult";
import QuestionRectMult from "@/components/QuestionRectMult";
import QuestionRectSingle from "@/components/QuestionRectSingle";
import QuestionAddress from "@/components/QuestionAddress";
import QuestionDate from "@/components/QuestionDate";
import QuestionDropDownBox from "@/components/QuestionDropDownBox";
import QuestionImage from "@/components/QuestionImage";
import QuestionSort from "@/components/QuestionSort";
import QuestionCity from "@/components/QuestionCity";
import QuestionTime from "@/components/QuestionTime";
import QuestionMu from "@/components/QuestionMu";
import QuestionMatrixBlank from "@/components/QuestionMatrixBlank";
import QuestionUploadFile from "@/components/QuestionUploadFile";
import QuestionParagraph from "@/components/QuestionParagraph";
import QuestionRate from "@/components/QuestionRate";
import QuestionMatrixRate from "@/components/QuestionMatrixRate";
import QuestionPaging from "@/components/QuestionPaging";
import QuestionCrosswiseBlank from "@/components/QuestionCrosswiseBlank";
import CheckType from '@/util/JSON/checkType.json';
export default {
  inject: ["reload"],
  name: "wjEdit",
  components: {
    QuestionJudge,
    QuestionSingle,
    QuestionMult2,
    QuestionBlank,
    QuestionBlankMult,
    QuestionRectMult,
    QuestionRectSingle,
    QuestionAddress,
    QuestionDate,
    QuestionDropDownBox,
    QuestionImage,
    QuestionSort,
    QuestionCity,
    QuestionTime,
    QuestionMu,
    QuestionMatrixRate,
    QuestionUploadFile,
    QuestionParagraph,
    QuestionRate,
    QuestionMatrixBlank,
    QuestionPaging,
    QuestionCrosswiseBlank,
  },
  data() {
    return {
      curTkType: {},
      wjTypeList: [],
      selectTypeIndex: 0,
      centerDialogVisible: false,
      tkList: [],

      asklist: [],
      selectIndex: 0,
      curWjInfo: {},
      height: "",
      isCollapse: true,
      rightheight: 0,
      left: 0,
      top: 0,
      questionlist: [],
      display: "none",
      editIndex: -1,
      editOptionIndex: "0_0",
      currentSort: 0,
      content: [
        {
          ContentRes: "",
        },
        {
          lineInput: "",
        },
        {
          gapFil: "",
        },
        {
          multiline: "",
        },
      ],
      ifMustAnswer: "",
      startnum: 1,
      endnum: 500,
      inputLeast: "",
      inputMoster: "",
      questionsTypeId: "",
      value1: null,
      optionIfRandom: "",
      ifFixedLastOption: "",
      switchID: "",
      betweenGroupRandom: "",
      inGroupRandom: "",
      manualSetting: "",
      matrixLineRandom: "",
      matrixRankRandom: "",
      lineRankExchange: "",
      questionsType: "",
      questionLayout: "",
      questionlineRank: "",
      choice: [
        {
          leftChoice: "",
        },
        {
          rightChoice: "",
        },
        {
          sortsnums: "",
        },
      ],
      choiceContent: [
        {
          label: "不限",
          value: "0",
        },
        {
          label: "1项",
          value: "1",
        },
        {
          label: "2项",
          value: "2",
        },
      ],
      titleNumber: 0,
      cityChoice: [
        {
          label: "详细到“详细地址”",
          value: "0",
        },
        {
          label: "详细到“区县”",
          value: "1",
        },
        {
          label: "详细到“城市”",
          value: "2",
        },
        {
          label: "详细到“省份”",
          value: "3",
        },
      ],
      radioChoice: "",
    };
  },
  computed: {
		//选项验证类型
		ContentRestrictions () {
			return CheckType
		}
	},
  mounted: function () {
    let that = this;
    that.loadWjTypes();
    that.loadAskTypeData();
    var winHeight =
      document.body.clientHeight || document.documentElement.clientHeight;
    this.height = winHeight - 108;
    this.rightheight = winHeight - 60;
    window.onresize = () => {
      var winHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      this.height = winHeight - 108;
      this.rightheight = winHeight - 60;
    };

    //在mounted钩子函数绑定滚动条事件
    document
      .getElementById("wenjuan_list")
      .addEventListener("scroll", this.scroll);
    that.wid = sessionStorage.getItem("wid") || 0;
    if (that.wid == 0) {
      this.wjadd();
    } else {
      sessionStorage.setItem("wid", that.wid);
      this.wjinfo();
    }
  },
  watch: {
    startnum(oldval, newval) {
      console.log("oldval", oldval, "=====", "newval", newval);
      if (this.startnum <= 0) {
        this.startnum = 0;
      }
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupleast}`,
        method: "POST",
        data: {
          id: that.switchID,
          least: oldval,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    endnum(oldval, newval) {
      console.log("oldval", oldval, "====", "newval", newval);
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupmost}`,
        method: "POST",
        data: {
          id: that.switchID,
          most: oldval,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
  },
  methods: {
    // 1ok
    loadWjTypes() {
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.queryQuestionTypes,
        data: {},
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.wjTypeList = res.resultBody.datas;
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    showQuestionList(index, item) {
      this.centerDialogVisible = true;
      this.typeIndex = index;
      this.curTkType = item;
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.queryTestQuestions,
        data: {
          questionTypeId: item.id,
          questionsName: that.searchQuestionsName,
        },
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.tkList = res.resultBody.datas;
            return;
          } else {
            that.tkList = [];
          }
        },
      };
      this.$util.request(params);
    },
    addTkItem(item) {
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.addNewQuestions,
        data: {
          questionnaireId: this.curWjInfo.id,
          questions: [item.id],
        },
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.centerDialogVisible = false;
            that.loadQuestionList();
            setTimeout(() => {
              let div = document.getElementById("wenjuan_list");
              div.scrollTop = div.scrollHeight;
            }, 400);
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    wjinfo() {
      let that = this;
      let id = that.wid;
      let params = {
        that: this,
        url: `${this.$config.service.wjinfo}?id=${id}`,
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.curWjInfo = res.resultBody;
            that.loadQuestionList();
          }
        },
      };
      this.$util.request(params);
    },
    wjadd() {
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.wjadd,
        data: {
          content: "",
          wjTitle: "问卷标题",
          wjType: "问卷类型",
        },
        cb(res) {
          if (res.code == 0) {
            that.curWjInfo = res.resultBody;
            sessionStorage.setItem("wid", that.curWjInfo.id);
            // that.loadQuestionList();
          }
        },
      };
      this.$util.request(params);
    },

    choiceNum(val, id) {
      console.log("11111", val, id);
    },
    loadAskTypeData() {
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.questionTypeList,
        data: {},
        cb(res) {
          if (res.code == 0) {
            that.asklist = res.resultBody.questionTypeOneList;
						that.asklist = that.asklist.map((info) => {
							info.questionTypeList = info.questionTypeList.map(val => {
								val.type = val.type.toString()
								return val
							})
							return info
						})
          }
        },
      };
      this.$util.request(params);
    },
    selectTypeQuestion(index, item) {
      this.selectTypeIndex = index;
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.questionadd,
        data: {
          questionnaireId: that.curWjInfo.id,
          questionsTypeId: item.id,
          editIndex: that.editIndex,
        },
        cb(res) {
          if (res.code == 0) {
            that.$message.success(res.message);
            if (that.editIndex > 0) {
              that.questionlist.splice(that.editIndex + 1, 0, res.resultBody);
              that.editIndex = that.editIndex + 1;
            } else {
              that.questionlist.push(res.resultBody);
              that.editIndex = that.questionlist.length - 1;
            }
            that.editCurQuestion = that.questionlist[that.editIndex];
            if (res.resultBody.questionsTypeId == 26) {
              if (that.questionlist[0].questionTypeId != 26) {
                console.log(res.resultBody.questionsSonList[0]);
                that.questionlist.unshift(res.resultBody.questionsSonList[0]);
              }
            }
            if (that.editIndex < 0) {
              setTimeout(() => {
                let div = document.getElementById("wenjuan_list");
                div.scrollTop = div.scrollHeight;
              }, 400);
            }
            that.calcequestionindex();
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    scroll() {
      let that = this;
      that.display = "none";
    },
    wjedit() {
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.wjedit,
        data: {
          content: that.curWjInfo.content,
          wjTitle: that.curWjInfo.wjTitle,
          id: that.curWjInfo.id,
        },
        cb(res) {
          if (res.code == 0) {
            that.$message.success(res.message);
          }
        },
      };
      this.$util.request(params);
    },
    showAdvance() {},
    loadQuestionList() {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.questionlist}?id=${that.curWjInfo.id}`,
        method: "GET",
        data: {},
        cb(res) {
          if (res.code == 0) {
            that.questionlist = res.resultBody.questionsList;
            console.log(that.questionlist);
            that.resultBody = res.resultBody;
            that.wjId = res.resultBody.id;
          }
        },
      };
      this.$util.request(params);
    },
    questiondel(id) {
      let that = this;
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          let params = {
            that: that,
            url: `${that.$config.service.questiondel}?id=${id}`,
            data: {},
            cb(res) {
              if (res.code == 0) {
                that.questionlist = [];
                that.loadQuestionList();
                that.$message.success(res.message);
                return;
              }
              that.$message.error(res.message);
            },
          };
          that.$util.request(params);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    setEditIndex(index) {
      let that = this;
      let curselected = document.getElementById(this.editIndex);
      if (curselected) {
        curselected.classList.remove("item_container_hover");
      }
      document.getElementById(index).classList.add("item_container_hover");
      this.editIndex = index;
      that.editCurQuestion = that.questionlist[that.editIndex];
      that.ifMustAnswer = that.editCurQuestion.ifMustAnswer == 1 ? true : false;
      that.optionIfRandom =
        that.editCurQuestion.optionIfRandom == 1 ? true : false;
      that.questionsTypeId = that.questionlist[index].questionsTypeId;
      that.switchID = that.questionlist[index].id;
      that.ifMustAnswer = that.questionlist[index].ifMustAnswer;
      that.optionIfRandom = that.questionlist[index].optionIfRandom;
      that.betweenGroupRandom = that.questionlist[index].betweenGroupRandom;
      that.inGroupRandom = that.questionlist[index].inGroupRandom;
      that.manualSetting = that.questionlist[index].manualSetting;
      that.matrixLineRandom = that.questionlist[index].matrixLineRandom;
      that.matrixRankRandom = that.questionlist[index].matrixRankRandom;
      that.lineRankExchange = that.questionlist[index].lineRankExchange;
      that.ifFixedLastOption = that.questionlist[index].ifFixedLastOption;
      that.questionsType = that.questionlist[index].ifMustSingle;
      that.questionLayout = that.questionlist[index].choiceLayout;
      that.questionlineRank = that.questionlist[index].inputBoxSetting;
      console.log("选中输出", that.ifMustAnswer);
      console.log(that.questionlist[index].questionsTypeId);
    },
    setEditOptionIndex(childIndex) {
      this.editOptionIndex = this.editIndex + "_" + childIndex;
    },
    wjupdquestionoption(item) {
      let url = `${this.$config.service.questionupd}`;
      let that = this;
      let params = {
        that: this,
        url: url,
        data: {
          id: item.id,
          questionsName: item.questionsName,
        },
        cb(res) {
          if (res.code == 0) {
            that.$message.success(res.message);
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    wjupdoption(item) {
      let url = `${this.$config.service.questionupdoption}`;
      let that = this;
      let params = {
        that: this,
        url: url,
        data: {
          id: item.id,
          labelName: item.labelName,
        },
        cb(res) {
          if (res.code == 0) {
            that.$message.success(res.message);
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    wjaddquestionoption(options, item, type = 0) {
      if (type == 2) {
        this.editCurQuestion = item;
        this.batchDialog = true;
        this.batchlist = "";
        return;
      }
      let url = `${this.$config.service.addoneoption}?id=${item.id}`;
      if (type == 1) {
        url = `${this.$config.service.addoneotheroption}?id=${item.id}`;
      }
      let that = this;
      let params = {
        that: this,
        url: url,
        data: {},
        cb(res) {
          if (res.code == 0) {
            options.push(res.resultBody);
            that.$message.success(res.message);
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    wjdelquestionoption(options, item, childindex) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.deloneoption}?id=${item.id}`,
        data: {},
        cb(res) {
          if (res.code == 0) {
            options.splice(childindex, 1);
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    addMatrixQuestionsOption(options, item) {
      let url = `${this.$config.service.addMatrixQuestionsOption}`;
      let that = this;
      let params = {
        that: this,
        url: url,
        data: {
          questionsId: item.id,
        },
        cb(res) {
          if (res.code == 0) {
            options.push(res.resultBody.datas[0]);
            that.$message.success(res.message);
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    addQuestionItem(item) {
      console.log(item, "111");
      let that = this;
      let params = {
        that: this,
        url: this.$config.service.questionadd,
        data: {
          questionnaireId: that.curWjInfo.id,
          questionsId: item.id,
        },
        cb(res) {
          if (res.code == 0) {
            this.reload();
            that.$message.success(res.message);
            item.questionsSonList.push(res.resultBody);
            return;
          }
          that.$message.error(res.message);
        },
      };
      this.$util.request(params);
    },
    mustAnswer(id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupifmustanswer}`,
        method: "POST",
        data: {
          id: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("设置成功后输出", that.ifMustAnswer);
            that.loadQuestionList();
          }
        },
      };
      this.$util.request(params);
    },
    setInputSize(index, id) {
      this.currentSort = index;
      console.log("点击时输出", index);
      console.log("1", id);
      let inputSize = 0;
      if (index == 0 || index == 3) {
        inputSize = 30;
      } else if (index == 1 || index == 4) {
        inputSize = 60;
      } else if (index == 2 || index == 5) {
        inputSize = 90;
      }
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setInputBoxSize}`,
        method: "POST",
        data: {
          id: id,
          inputBoxSize: inputSize,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);

            that.loadQuestionList();
          }
        },
      };
      this.$util.request(params);
    },
    contents(val, id) {
      console.log("改变输出", val);
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setIfLengthLimit}`,
        method: "POST",
        data: {
          id: id,
          ifLengthLimit: val,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    switchoverType(num, id) {
      this.questionlineRank = num;
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.questionInputBox}`,
        method: "POST",
        data: {
          id: id,
          inputBoxSetting: num,
        },
        cb(res) {
          if (res.code == 0) {
            that.reload();
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    inpLeast(value, id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupleast}`,
        method: "POST",
        data: {
          id: id,
          least: value,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    inpMoster(value, id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupmost}`,
        method: "POST",
        data: {
          id: id,
          least: value,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    RandomArr(id) {
      console.log(id);
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupoptionifrandom}`,
        method: "POST",
        data: {
          id: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    fixation(id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.fixedlastoption}`,
        method: "POST",
        data: {
          id: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    setTopic(index, id) {
      this.questionsType = index;
      if (index == 1) {
        let that = this;
        let params = {
          that: this,
          url: `${this.$config.service.setupsingleoption}`,
          method: "POST",
          data: {
            id: id,
          },
          cb(res) {
            if (res.code == 0) {
              that.reload();
              console.log("输出", res);
            }
          },
        };
        this.$util.request(params);
      } else if (index == 2) {
        let that = this;
        let params = {
          that: this,
          url: `${this.$config.service.setupmanyoption}`,
          method: "POST",
          data: {
            id: id,
          },
          cb(res) {
            if (res.code == 0) {
              that.reload();
              console.log("输出", res);
            }
          },
        };
        this.$util.request(params);
      }
    },
    setLayout(index, id) {
      this.questionLayout = index;
      console.log(index, id);
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.choiceLayout}`,
        method: "POST",
        data: {
          id: id,
          choiceLayout: index,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
            that.reload();
          }
        },
      };
      this.$util.request(params);
    },
    betRan(id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setBetweenGroupRandom}`,
        method: "POST",
        data: {
          id: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    inGroupR(id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setInGroupRandom}`,
        method: "POST",
        data: {
          id: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    manSet(id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.BoxAppearance}`,
        method: "POST",
        data: {
          id: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    setDetails(id, val) {
      console.log("城市选择输出", id, val);
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.setupCitySelection}`,
        method: "POST",
        data: {
          choiceRange: val.value,
          questionsId: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
            that.loadQuestionList();
          }
        },
      };
      this.$util.request(params);
    },
    lineMartix(id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.MatrixLineRandom}`,
        method: "POST",
        data: {
          id: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    RankMartix(id) {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.MatrixRankRandom}`,
        method: "POST",
        data: {
          id: id,
        },
        cb(res) {
          if (res.code == 0) {
            console.log("输出", res);
          }
        },
      };
      this.$util.request(params);
    },
    lineRank(id) {
      // let that = this;
      // let params = {
      //     that: this,
      //     url: `${this.$config.service.MatrixRankRandom}`,
      //     method: "POST",
      //     data:{
      //         id:id
      //     },
      //     cb(res) {
      //         if (res.code == 0) {
      //             console.log('输出',res)
      //         }
      //     }
      // };
      // this.$util.request(params);
    },
  },
};
</script>

<style scoped>
.heade {
  padding: 0px 4px;
  border: 1px solid #ccc;
}
.activeCheck {
  border: 1px solid #0080ff !important;
  color: #0080ff;
}
.wjType {
  width: 350px;
  float: right;
  display: inline;
  background-color: #fff;
}
.heiSetting {
  height: 49px;
  line-height: 49px;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
}
.left {
  float: left;
  margin-left: 6px;
}
.right {
  float: right;
}
.tab_layout span {
  padding: 1px 7px;
  border: 1px solid #ccc;
}
/deep/.right .el-input__inner {
  width: 94px !important;
  height: 24px !important;
  border: 1px solid #ccc !important;
}
</style>

<style>
.operate_item {
  height: 60px;
  line-height: 60px;
  width: 90%;
  margin: 0px auto;
}
.display_inline {
  display: inline;
  float: left;
  height: 68px;
  line-height: 68px;
}
.el-input__inner:hover {
  border: 1px dashed #c0c4cc !important;
}
input {
  border: 0px !important;
}
.wjTitle > input {
  border: 0px !important;
  text-align: center;
}
.item_container_hover {
  border: 2px #409eff solid;
  border-radius: 3px;
}
.item_container {
  margin-top: 8px;
  background-color: #fff;
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-top: 6px;
  padding-bottom: 6px;
}
.operate_td {
  width: 30px;
  height: 30px;
  font-size: 26px;
  background-color: cornflowerblue;
  text-align: center;
  line-height: 30px;
}
.qtypeItem {
  text-align: center;
  display: inline;
  float: left;
  width: 80px;
  height: 80px;
  border: 1px solid #eaeaea;
}
.wjTypeChildItemFont {
  font-size: 14px;
  cursor: pointer;
}
.wjTypeChildQuestion {
  margin-left: 2px;
  width: 278px;
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 30px;
  float: left;
  display: inline;
  overflow-y: auto;
  border-top: 1px solid #ccc;
}
.tk_item {
  width: 260px;
  height: 69px;
  margin: 0 auto;
  border-bottom: 1px solid #d5d5d6;
}
.display_inline {
  display: inline;
  float: left;
  height: 68px;
  line-height: 68px;
}
.wjTypeChildQuestion {
  margin-left: 2px;
  width: 278px;
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 30px;
  float: left;
  display: inline;
  overflow-y: auto;
}
</style>